module.exports = __webpack_public_path__ + "img/logo-light.c15cb750.svg";